import styled from "styled-components";

export const FooterWrapper = styled.div`
  .head {
    display: flex;
    justify-content: center;
    text-decoration: underline;
    background: black;
    padding-top: 30px;
    padding-bottom: 35px;
  }
  .divide {
    display: flex;
    justify-content: center;
    background: black;
    padding-bottom: 35px;
  }
  .left-half {
  }
  .right-half {
  }
  .fontL {
    font-size: 18px;
    font-weight: 900;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
  .fontR {
    display: flex;
    justify-content: center;
    font-size: 18px;
    font-weight: 900;
    margin-bottom: 20px;
  }
  .fontR1 {
    display: flex;
    justify-content: center;
    margin-bottom: 18px;
  }
  .fontR2 {
    display: flex;
    justify-content: center;
    margin-bottom: 33px;
    margin-left: -25px;
  }
  .fontL1 {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    padding-left: 28px;
  }
  .fontL2 {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
  }
  .fontL3 {
    display: flex;
    justify-content: center;
    padding-left: 38px;
    margin-bottom: 36px;
  }
`;
